export const subscribeNewsLetter = (firstName, lastName, email) => {
  return fetch(`${__BASE_API_URL__}/subscribe?firstName=${firstName}&lastName=${lastName}&email=${email}`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  })
  .then(res => res.json())
  .then(() => {
    return true;
  })
  .catch(() => {
    return false;
  });
};